import type { HTMLAttributes } from 'react';

import React from 'react';

import { classNames } from '../../../utils/class-names';

import styles from './table-header.module.css';

export type TableHeaderProps = { sticky?: boolean } & HTMLAttributes<HTMLTableSectionElement>;

export function TableHeader({ sticky, className, ...props }: TableHeaderProps) {
  return <thead {...props} className={classNames(className, styles.table, sticky && styles.sticky)} />;
}
